export type InsightCategory = 'Markets' | 'Tax' | 'Estate planning' | 'Family governance' | 'Portfolio'

export interface Insight {
  slug: string
  title: string
  excerpt: string
  category: InsightCategory
  author: string
  date: string
  readMinutes: number
}

export const insightCategories: InsightCategory[] = [
  'Markets',
  'Portfolio',
  'Tax',
  'Estate planning',
  'Family governance',
]

export const insights: Insight[] = [
  {
    slug: 'midcap-valuations-q3',
    title: 'What stretched mid-cap valuations mean for a ten-year portfolio',
    excerpt:
      'Mid-caps have re-rated faster than earnings. What we changed in the model portfolios this quarter, and what we deliberately left alone.',
    category: 'Markets',
    author: 'Prashanth Sekhar',
    date: '2026-09-02',
    readMinutes: 7,
  },
  {
    slug: 'private-trust-basics',
    title: 'A private trust is not a tax shelter. Here is what it actually does',
    excerpt:
      'The most common reason families set up a trust is the least useful one. A plain-language guide to when a trust earns its cost.',
    category: 'Estate planning',
    author: 'Prashanth Sekhar',
    date: '2026-08-21',
    readMinutes: 9,
  },
  {
    slug: 'harvesting-calendar',
    title: 'Building a capital gains harvesting calendar for the family',
    excerpt:
      'Sequencing matters more than selection in the last quarter of the financial year. The framework we use with every advisory family.',
    category: 'Tax',
    author: 'Prashanth Sekhar',
    date: '2026-08-06',
    readMinutes: 6,
  },
  {
    slug: 'private-markets-reality',
    title: 'Private markets, honestly: what an allocation can and cannot do',
    excerpt:
      'Fifteen years on both sides of the table. Where unlisted exposure genuinely adds to a family portfolio, and where it is illiquidity dressed as alpha.',
    category: 'Portfolio',
    author: 'Prashanth Sekhar',
    date: '2026-07-28',
    readMinutes: 8,
  },
  {
    slug: 'family-charter',
    title: 'Writing a family charter that the next generation will actually read',
    excerpt:
      'Most charters are drafted by lawyers and filed away. The ones that work are short, specific, and written by the family itself.',
    category: 'Family governance',
    author: 'Prashanth Sekhar',
    date: '2026-07-11',
    readMinutes: 10,
  },
  {
    slug: 'nri-repatriation',
    title: 'When a child moves abroad: repatriation and residency housekeeping',
    excerpt:
      'A checklist for families whose next generation has become non-resident, covering accounts, nominations and the tax year overlap.',
    category: 'Tax',
    author: 'Prashanth Sekhar',
    date: '2026-06-24',
    readMinutes: 7,
  },
  {
    slug: 'due-diligence-shelf',
    title: 'Inside the approved shelf: how a fund gets on, and how it gets off',
    excerpt:
      'The seven tests every product clears before it can be recommended to a family in any of our offices.',
    category: 'Portfolio',
    author: 'Prashanth Sekhar',
    date: '2026-06-09',
    readMinutes: 11,
  },
  {
    slug: 'business-sale-proceeds',
    title: 'You just sold the business. What happens in the first ninety days',
    excerpt:
      'Liquidity events are where most family wealth is quietly lost. A deliberate, unhurried sequence for deploying a large one-time corpus.',
    category: 'Markets',
    author: 'Prashanth Sekhar',
    date: '2026-05-30',
    readMinutes: 9,
  },
]
